// extracted by mini-css-extract-plugin
export default {"gpa__membership_section":"Membership_gpa__membership_section__dIxuu","gpa__membership":"Membership_gpa__membership__qkcwc"};